import React from "react";

const VillageCoverageSection = ({
  data,
  summary,
  title,
  detailed = false,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center text-balance">
          {title}
        </h3>
        <div className="text-center py-8">
          <div className="animate-spin h-8 w-8 border-b-2 border-teal-700 rounded-full mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading village coverage data...</p>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg  shadow-sm">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center text-balance">
          {title}
        </h3>
        <div className="text-center py-10 text-gray-500">
          No village coverage data available
        </div>
      </div>
    );
  }

  // Filter out districts with 0 villages for display (optional)
  const filteredData = data.filter(
    (item) => item.totalVillages > 0 || item.totalBoqsInDistrict > 0
  );

  // Sort by coverage percentage descending
  const sortedData = [...filteredData].sort(
    (a, b) => (b.coveragePercentage || 0) - (a.coveragePercentage || 0)
  );

  // Helper function to get status color
  const getStatusColor = (coverage) => {
    const coverageNum = Number(coverage) || 0;
    if (coverageNum >= 75) return "bg-[#E6F2F2] text-[#0B5557]";
    if (coverageNum >= 50) return "bg-[#FBF6E6] text-[#8C6A12]";
    if (coverageNum > 0) return "bg-[#EEF2F6] text-[#34495E]";
    return "bg-gray-100 text-gray-800";
  };

  // Format numbers with K/M suffixes
  const formatNumber = (num) => {
    if (!num && num !== 0) return "0";

    const number = Number(num);
    if (isNaN(number)) return "0";

    if (number >= 1000000) return `${(number / 1000000).toFixed(2)}M`;
    if (number >= 1000) return `${(number / 1000).toFixed(1)}K`;
    return number.toLocaleString();
  };

  // Format cost with K/M suffixes
  const formatCost = (cost) => {
    if (!cost && cost !== 0) return "0";

    const numCost = Number(cost);
    if (isNaN(numCost)) return "0";

    if (numCost >= 1000000) return `${(numCost / 1000000).toFixed(2)}M`;
    if (numCost >= 1000) return `${(numCost / 1000).toFixed(1)}K`;
    return `${numCost.toLocaleString()}`;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center mb-4 text-balance">
        {title}
      </h3>

      {/* Summary Stats */}
      {/* {summary && summary.formattedData && (
        <div className="mb-6 p-4 bg-[#E6F2F2] rounded-lg border border-[#7FBFC1]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center">
              <div className="text-sm font-medium text-gray-600">
                Total Districts
              </div>
              <div className="text-xl font-bold text-[#137E81]">
                {summary.formattedData.formattedTotalDistricts || "0"}
                <span className="text-sm font-normal text-gray-600 ml-2">
                  ({summary.formattedData.formattedDistrictsWithBOQs || "0"}{" "}
                  with BOQs)
                </span>
              </div>
            </div>
            <div className="text-center">
              <div className="text-sm font-medium text-gray-600">
                Total Villages
              </div>
              <div className="text-xl font-bold text-[#137E81]">
                {summary.formattedData.formattedTotalVillages || "0"}
                <span className="text-sm font-normal text-gray-600 ml-2">
                  ({summary.formattedData.formattedTotalVillagesWithBoqs || "0"}{" "}
                  with BOQs)
                </span>
              </div>
            </div>
            <div className="text-center">
              <div className="text-sm font-medium text-gray-600">
                Total BOQs
              </div>
              <div className="text-xl font-bold text-[#137E81]">
                {summary.formattedData.formattedTotalBoqs || "0"}
              </div>
            </div>
            <div className="text-center">
              <div className="text-sm font-medium text-gray-600">Coverage</div>
              <div className="text-xl font-bold text-teal-700">
                {summary.formattedData.formattedOverallCoveragePercentage ||
                  "0%"}
              </div>
            </div>
            <div className="text-center">
              <div className="text-sm font-medium text-gray-600">
                Total Cost
              </div>
              <div className="text-xl font-bold text-[#137E81]">
                {summary.formattedData.formattedOverallTotalCost || "0"}
              </div>
            </div>
            <div className="text-center">
              <div className="text-sm font-medium text-gray-600">
                Avg. Cost/BOQ
              </div>
              <div className="text-xl font-bold text-[#137E81]">
                {summary.formattedData.formattedOverallAverageCost || "0"}
              </div>
            </div>
          </div>
        </div> */}
      {/* )} */}

      {/* Detailed Table */}
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-[#137e81]">
            <tr>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                District
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Total Villages
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Villages with BOQs
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Coverage %
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Total BOQs
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Total Cost
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Avg. Cost/BOQ
              </th>
              {/* <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Share of Total
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider">
                Status
              </th> */}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {sortedData.map((district, index) => {
              const coveragePercentage =
                Number(district?.coveragePercentage) || 0;
              const totalVillages = Number(district?.totalVillages) || 0;
              const villagesWithBoqs = Number(district?.villagesWithBoqs) || 0;
              const totalBoqsInDistrict =
                Number(district?.totalBoqsInDistrict) || 0;
              const totalCost = Number(district?.totalCost) || 0;
              const averageCost = Number(district?.averageCost) || 0;

              return (
                <tr
                  key={district?.districtId || index}
                  className={
                    index % 2 === 0
                      ? "bg-white hover:bg-gray-50"
                      : "bg-gray-50 hover:bg-gray-100"
                  }
                >
                  {/* District Name */}
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center">
                      {/* <div className="w-2 h-2 rounded-full mr-2 bg-blue-500"></div> */}
                      <span className="text-sm font-medium text-gray-900">
                        {district?.districtName || "Unknown District"}
                      </span>
                    </div>
                  </td>

                  {/* Total Villages */}
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="text-sm font-bold text-gray-900">
                      {totalVillages.toLocaleString()}
                    </div>
                    {/* <div className="text-xs text-gray-500">
                      {district?.formattedData?.totalVillagesFormatted ||
                        formatNumber(totalVillages)}
                    </div> */}
                  </td>

                  {/* Villages with BOQs */}
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="text-sm font-bold text-gray-900">
                      {villagesWithBoqs.toLocaleString()}
                    </div>
                    {/* <div className="text-xs text-gray-500">
                      {district?.formattedData?.villagesWithBoqsFormatted ||
                        formatNumber(villagesWithBoqs)}
                    </div> */}
                  </td>

                  {/* Coverage Percentage */}
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="text-sm font-bold text-gray-900">
                      {coveragePercentage.toFixed(1)}%
                    </div>
                    {/* <div className="text-xs text-gray-500">
                      {district?.formattedData?.coveragePercentageFormatted ||
                        `${coveragePercentage.toFixed(1)}%`}
                    </div> */}
                  </td>

                  {/* Total BOQs */}
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="text-sm font-bold text-gray-900">
                      {totalBoqsInDistrict.toLocaleString()}
                    </div>
                    {/* <div className="text-xs text-gray-500">
                      {district?.formattedData?.boqCountFormatted ||
                        formatNumber(totalBoqsInDistrict)}
                    </div> */}
                  </td>

                  {/* Total Cost */}
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    {/* <div className="text-sm font-bold text-gray-900">
                      {formatCost(totalCost)}
                    </div> */}
                    <div className="text-xs text-gray-500">
                      {district?.formattedData?.formattedTotalCost || "0"}
                    </div>
                  </td>

                  {/* Average Cost per BOQ */}
                  <td className="px-4 py-3 whitespace-nowrap text-center">
                    {/* <div className="text-sm font-bold text-gray-900">
                      {formatCost(averageCost)}
                    </div> */}
                    <div className="text-xs text-gray-500">
                      {district?.formattedData?.formattedAverageCost || "0"}
                    </div>
                  </td>

                  {/* Share of Total */}
                  {/* <td className="px-4 py-3 whitespace-nowrap text-center">
                    <div className="space-y-1">
                      <div className="flex items-center justify-center">
                        <span className="text-xs font-medium bg-[#E6F2F2] text-[#0B5557] px-2 py-1 rounded">
                          BOQs:{" "}
                          {district?.formattedPercentages
                            ?.boqPercentageFormatted || "0%"}
                        </span>
                      </div>
                      <div className="flex items-center justify-center">
                        <span className="text-xs font-medium bg-[#E6F2F2] text-[#0B5557] px-2 py-1 rounded">
                          Cost:{" "}
                          {district?.formattedPercentages
                            ?.costPercentageFormatted || "0%"}
                        </span>
                      </div>
                    </div>
                  </td>

                  {/* Status */}
                  {/* <td className="px-4 py-3 whitespace-nowrap text-center">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
                        coveragePercentage
                      )}`}
                    >
                      {coveragePercentage >= 75
                        ? "Excellent"
                        : coveragePercentage >= 50
                        ? "Good"
                        : coveragePercentage > 0
                        ? "Low"
                        : "No Coverage"}
                    </span>
                  </td>  */}
                </tr>
              );
            })}

            {/* Summary Row */}
            {summary && (
              <tr className="bg-[#137e81] text-white font-bold">
                <td className="px-4 py-3 whitespace-nowrap">
                  <div className="flex items-center">
                    {/* <div className="w-2 h-2 rounded-full mr-2 bg-white"></div> */}
                    <span>TOTAL</span>
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  {/* <div>{(summary.totalVillages || 0).toLocaleString()}</div> */}
                  <div className="text-xs opacity-80">
                    {summary.formattedData?.formattedTotalVillages || "0"}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  <div>
                    {/* {(summary.totalVillagesWithBoqs || 0).toLocaleString()} */}
                  </div>
                  <div className="text-xs opacity-80">
                    {summary.formattedData?.formattedTotalVillagesWithBoqs ||
                      "0"}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  <div>
                    {/* {(summary.overallCoveragePercentage || 0).toFixed(1)}% */}
                  </div>
                  <div className="text-xs opacity-80">
                    {summary.formattedData
                      ?.formattedOverallCoveragePercentage || "0%"}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  {/* <div>{(summary.totalBoqs || 0).toLocaleString()}</div> */}
                  <div className="text-xs opacity-80">
                    {summary.formattedData?.formattedTotalBoqs || "0"}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  {/* <div>{formatCost(summary.overallTotalCost)}</div> */}
                  <div className="text-xs opacity-80">
                    {summary.formattedData?.formattedOverallTotalCost || "0"}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  {/* <div>{formatCost(summary.overallAverageCost)}</div> */}
                  <div className="text-xs opacity-80">
                    {summary.formattedData?.formattedOverallAverageCost || "0"}
                  </div>
                </td>
                {/* <td className="px-4 py-3 whitespace-nowrap text-center">
                  <div className="space-y-1">
                    <div className="text-xs opacity-80">100% of BOQs</div>
                    <div className="text-xs opacity-80">100% of Cost</div>
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white text-[#137e81]">
                    OVERALL
                  </span>
                </td> */}
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Key Insights */}
      {detailed && summary && sortedData.length > 0 && (
        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <h4 className="text-sm font-semibold text-gray-700 mb-3 text-balance">
            Key Insights
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {/* District with highest coverage */}
            {sortedData.length > 0 &&
              (sortedData[0]?.coveragePercentage || 0) > 0 && (
                <div className="bg-white p-3 rounded border">
                  <div className="text-xs text-[#137E81] font-medium mb-1">
                    Highest Coverage
                  </div>
                  <div className="font-bold text-gray-800">
                    {sortedData[0]?.districtName || "Unknown"}
                  </div>
                  <div className="text-sm text-[#137E81]">
                    {(sortedData[0]?.coveragePercentage || 0).toFixed(1)}%
                    coverage
                  </div>
                </div>
              )}

            {/* District with most BOQs */}
            {sortedData.length > 0 && (
              <div className="bg-white p-3 rounded border">
                <div className="text-xs text-[#137E81] font-medium mb-1">
                  Most BOQs
                </div>
                <div className="font-bold text-gray-800">
                  {[...sortedData].sort(
                    (a, b) =>
                      (b?.totalBoqsInDistrict || 0) -
                      (a?.totalBoqsInDistrict || 0)
                  )[0]?.districtName || "Unknown"}
                </div>
                <div className="text-sm text-[#137E81]">
                  {[...sortedData].sort(
                    (a, b) =>
                      (b?.totalBoqsInDistrict || 0) -
                      (a?.totalBoqsInDistrict || 0)
                  )[0]?.totalBoqsInDistrict || 0}{" "}
                  BOQs
                </div>
              </div>
            )}

            {/* District with highest total cost */}
            {sortedData.length > 0 && (
              <div className="bg-white p-3 rounded border">
                <div className="text-xs text-[#137E81] font-medium mb-1">
                  Highest Budget
                </div>
                <div className="font-bold text-gray-800">
                  {[...sortedData].sort(
                    (a, b) => (b?.totalCost || 0) - (a?.totalCost || 0)
                  )[0]?.districtName || "Unknown"}
                </div>
                {/* <div className="text-sm text-[#137E81]">
                  {formatCost(
                    [...sortedData].sort(
                      (a, b) => (b?.totalCost || 0) - (a?.totalCost || 0)
                    )[0]?.totalCost
                  )}
                </div> */}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VillageCoverageSection;
